import { initVideoListener, addToWishlist, removeFromWishlist, setFavorites, initComponent, renderPageInModal,showModalLogin } from "@api/utils_2020";
const swipeCSS = require("photoswipe/dist/photoswipe.css");
const swipeUI = require("photoswipe/dist/default-skin/default-skin.css");

export default () => {
    const portobelloService =  Util.service("WSPortobelloSite", true, {
        exceptionHandler: console.error,
        reflectSuccess: function(pbSiteService) {                    
            return pbSiteService;
        },
        reflectError: function() {
            console.error("Erro de conexão, verifique sua conexão com a internet.");
        },
    });

    var languageQr = window.location.href.substring(window.location.href.indexOf("language-qrcode"));
    if (languageQr == 'language-qrcode')
    {
        $("#languages-modal").addClass("show");
        $("body").addClass("showModal");
    }
    /*
    $("body").off("click",".jsFavorite").on("click",".jsFavorite", function(evt) {
        evt.preventDefault();
        const code = item.data("code");
        if (userLogged)
        {
            const item = $(this);            
            const suffix = item.data("suffix");
            const isChecked = item.hasClass("favorite-true");

            Util.service("WSPortobelloSite", true, {
                exceptionHandler: alertInterface.showError,
                reflectSuccess: function(service) {
                    var wishListService = service;
                    
                    if (!isChecked) {
                        addToWishlist({
                            code,
                            suffix,
                            service: wishListService,
                            type: "products",
                        });
            
                        item.addClass("favorite-true");
                        $('a[data-code="'+code+'"] img.favorite-false').hide();
                        $('a[data-code="'+code+'"] img.favorite-true').show();
                    } else {
                        removeFromWishlist({
                            code,
                            suffix,
                            type: "products",
                        });
            
                        item.removeClass("favorite-true");
                        $('a[data-code="'+code+'"] img.favorite-true').hide();
                        $('a[data-code="'+code+'"] img.favorite-false').show();
                    }
                },
                reflectError: function() {
                    console.error("Erro de conexão, verifique sua conexão com a internet.");
                },
            });  
        } else {
            const link = $(this).attr('href');
            // não logado
            initVideoListener();
            showModalLogin(link);
            Util.setCookie('wishlistAdd',code+'|products');
        }     
    });
    */
    
    //$('body').off('click','.pb-productgrouppretlist .scroll-container li a').on('click','.pb-productgrouppretlist .scroll-container li a',function(e)
    //{
    //    e.preventDefault();
    //    const link = $(this).attr('href');
    //    function initPage()
    //    {
    //        import( /* webpackChunkName: "/product" */ "./product.js" ).then((module) => module.default());            
    //        initComponent('pb-productheader-v2');
    //        initComponent('pb-relatedproducts'); 
    //        initComponent('pb-archtrendscarousel-v3');        
    //        initComponent('pb-findstore--static');                    
    //    }
    //    renderPageInModal(link, '#Product_view', initPage);
    //    return false;
    //});

    //$('body').off('click','#relatedproducts .pb-relatedproducts a').on('click','#relatedproducts .pb-relatedproducts a',function(e)
    //{
     //   e.preventDefault(); 
      //  const link = $(this).attr('href');
       // function initPage()
        //{
         //   import( /* webpackChunkName: "/productGroupColor" */ "./productGroupColor.js" ).then((module) => module.default());
          //  initComponent('pb-productgroupcarousel');
        //}
        //renderPageInModal(link, "#Product_groupcolor",initPage);        
        //return false;
    //});

    let zipInterval;
    $('body').off('click','.pb-downloads--buttons a[href="#zipsketchup"], a[href="#zipproducts"]').on('click','.pb-downloads--buttons a[href="#zipsketchup"], a[href="#zipproducts"]',function(e)
    {
        e.preventDefault();
        const idProduct = $(this).data('idproduct');
        const type = $(this).data('type');

        portobelloService.addZipToQueue(idProduct, type, {
            success: items => {
                if(items) {
                    if(items.hasZip) {
                        let link = document.createElement('a');                
                        link.href = items.hasZip;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else if(items) {
                        //UtilUi.loadTemplate("assets/components/pb-list--zip/pb-list--zip.tpl", (dataOn, tpl) => {
                            let zipItems = Object.values(items);
                            let html = tpl.fetch({ zipItems });
                            $("body").append(html);
    
                            zipInterval = setInterval(() => {
                                portobelloService.getMyZipList({
                                    success: refreshItems => {
                                        if(refreshItems) {
                                            UtilUi.loadTemplate("assets/components/pb-list--zip/pb-zip--items.tpl", (dataOn, tpl) => {
                                                zipItems = Object.values(refreshItems);
                                                html = tpl.fetch({ zipItems });
                                                $("#selected-list .items").html(html);
                                                $('#pb-modal--productdetails button[data-dismiss="modal"]').trigger('click');
                                            });
                                        } else {
                                            $("#selected-list").remove();
                                            clearInterval(zipInterval);
                                        }
                                    }
                                })
                            }, 10000);
                        //});
                    }
                } else {
                    alert('Houve um erro na requisição do seu download, tente novamente mais tarde!')
                }
            }
        })

        return false;
    });

    setFavorites("products");

};    
